<!--
[configStart]
{
  "lazyload": true,
  "iview": true,
  "pageInfo": {
    "title": "${WinInitData/page_info/title}",
    "linkIcon": "${WinInitData/page_info/icon}",
    "keywords": "融媒体解决方案、县级融媒体、县级融媒体解决方案、县级融媒体中心、融媒体平台、融媒体中心、融媒体建设、媒体融合、融媒体产品提供商、融媒体产品、融媒体软件、绩效考核、版权管理、政务服务、小程序开发、直播工具、AI语音、H5制作",
    "description": "ZAKER融媒体平台，基于高性能架构及云服务，为传统媒体与新媒体融合提供“舆情监测、全媒体内容生产、内容审核、多渠道一键分发、绩效考核统计、内容共享及版权管理、大数据分析、全媒体指挥调度、政务服务、营销案例共享、用户管理、广告投放、平台搭建、小程序、数据展示屏”等高度定制化的技术解决方案。",
    "pluginCss": [
      "../public/css/mCustomScrollbar.css"
    ],
    "pluginJs": [
      "../public/js/jquery.min.2.2.0.js",
      "../public/js/zepto.min.1.2.0.js",
      "../public/js/mCustomScrollbar.js"
    ],
    "macroSeo": ["index.html/index"]
  }
}
[configEnd]
-->
<template>
  <div class="index-page">
    <div class="fixed-nav-wrap" style="display:none;">
      <div class="fixed-nav-bar">
        <div class="fixed-nav"></div>
      </div>
      <div class="sub-nav-wrap">
        <div class="sub-nav-list">
          <a href="javascript:;" data-cls="live" class="active">直播套件</a>
          <a href="javascript:;" data-cls="hsm">红树莓 - 短视频</a>
          <a href="javascript:;" data-cls="ai">AI 语音合成</a>
          <a href="javascript:;" data-cls="vr">VR 全景</a>
          <a href="javascript:;" data-cls="h5">H5 平台</a>
          <a href="javascript:;" data-cls="design">云设计</a>
        </div>
      </div>
    </div>
    <div class="page-wrap">
      <div class="top-wrap">
        <div class="center-wrap">
          <div class="menu-wrap">
            <a :href="winPageData.index_page" class="logo-wrap">
              <img src="//zkres.myzaker.com/static/rmt/logo.png" class="logo" alt="logo" />
            </a>
            <div class="menu-list">
              <a href="javascript:;" title="合作方式">合作方式</a>
              <a class="user" v-if="winPageData.user_info" :href="winPageData.myorg_page">进入后台</a>
              <a :href="winPageData.login_page" v-else title="登录">登录</a>
              <!-- <a class="user" tal:condition="tplData/user_info"
                tal:attributes="href tplData/loginout_api; title tplData/user_info">退出登录</a> -->
            </div>
          </div>
          <div class="nav-list">
            <a href="javascript:;">全媒体生产工具</a>
            <a href="javascript:;">指挥调度</a>
            <a href="javascript:;">安全审核</a>
            <a href="javascript:;">舆情监控</a>
            <a href="javascript:;">内容管理</a>
            <a href="javascript:;">用户管理</a>
            <a href="javascript:;">融合发布</a>
            <a href="javascript:;">可视化</a>
            <a href="javascript:;">绩效统计</a>
            <a href="javascript:;">广告投放</a>
            <a href="javascript:;">营销平台</a>
            <a href="javascript:;">政务服务</a>
            <a href="javascript:;">App搭建</a>
            <a href="javascript:;">小程序开发</a>
            <a href="javascript:;">版权管理</a>
          </div>
        </div>
      </div>
      <div class="banner-wrap">
        <div class="banner-inner">
          <h2 class="banner-title">媒体融合业务的云服务超市</h2>
          <h3 class="banner-subtitle">深耕媒体融合实践4年，整合搭建新型媒体业务平台，<br />6套生产工具、7大融媒体系统、3大生产管理平台、2个发布端口、1套政务服务体系，<br />为媒体融合全领域赋能增效。</h3>
          <img src="//zkres.myzaker.com/static/rmt/banner.png" class="banner lazy" />
        </div>
      </div>
      <div class="block-wrap block-1">
        <div class="container">
          <div class="block-line">
            <div class="inner-block">
              <h2 class="block-1-title">核心产品</h2>
              <div class="pic lazy" v-lazy:background-image="picPath.b1"></div>
              <h3 class="block-1-subtitle">云服务超市，可自主挑选、搭配产品和服务</h3>
              <p class="block-1-content">
                从舆情监测、指挥调度，到全媒体内容生产、审核、分发、统计、考核、版权管理，再到经营服务、平台建设、可视化等，进行集约建设、模块化输出，并有专门团队进行定期升级、运维支持和长期培训服务。</p>
            </div>
            <div class="inner-block">
              <h2 class="block-1-title">行业地位</h2>
              <div class="pic lazy" v-lazy:background-image="picPath.b2"></div>
              <h3 class="block-1-subtitle">国内媒体融合第三条路径的创造者</h3>
              <p class="block-1-content">
                在“内容、渠道、平台、经营、管理”全领域与主流媒体深度融合，用跨区域、跨介质、跨产业的融合发展，为传媒产业的转型升级打开了想象空间。</p>
            </div>
          </div>
          <div class="block-line">
            <div class="inner-block">
              <h2 class="block-1-title">合作优势</h2>
              <div class="pic lazy" v-lazy:background-image="picPath.b3"></div>
              <h3 class="block-1-subtitle">‌‌资深团队深耕国内领先资讯平台ZAKER近九年
              </h3>
              <p class="block-1-content">
                出色的开发团队、前沿的核心技术，更理解媒体行业、更了解媒体运营，对新闻行业、媒体融合具备更长远的规划和运营支撑。</p>
            </div>
            <div class="inner-block">
              <h2 class="block-1-title">主要伙伴</h2>
              <div class="pic lazy" v-lazy:background-image="picPath.b4"></div>
              <h3 class="block-1-subtitle">已与各省市主流媒体合作4年</h3>
              <p class="block-1-content">
                已与“现代快报、潇湘晨报、新快报、新文化报、兰州日报、贵阳日报、南宁日报、辽沈晚报、新晚报、合肥晚报”等近30家主流媒体进行了合作。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap live" data-sec="0" data-third="0">
        <div class="container">
          <div class="icon-box">
            <div class="icon lazy" v-lazy:background-image="picPath.live_icon"></div>
          </div>
          <h2 class="block-title">直播套件</h2>
          <h3 class="block-subtitle">权威、轻量化移动PGC直播生产管理平台</h3>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.live"></div>
              <h3 class="block-title block-content-column-title">LIVE直播现场<span class="cha"></span>导播</h3>
              <p class="block-content-column-desc">
                多种终端、多机位超强映像表现能力：完美支持手机、无人机、摄像机、监控设备、VR摄像机等各种摄像设备，及推拉流适配。
              </p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.live5"></div>
              <h3 class="block-content-column-title">直播管理平台</h3>
              <p class="block-content-column-desc">
                高直播用户观看体验：重要信息以文字、图片（静态/Gif）等形式进行补充，背景音乐添加、预告片预热、用户评论互动和管理等；
                二次传播效果优化：回看下载剪辑，直播数据统计分析。
              </p>
            </div>
          </div>
          <a href="#" class="btn">了解详情</a>
          <a href="#" class="block-remark">点击链接查看更多内容</a>
          <div class="block-coop">
            <h2 class="coop-title">合作案例</h2>
            <div class="coop-content">
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c1"></div>
                <h3 class="coop-block-title">贵阳晚报《伙食团》1期/周</h3>
                <p class="coop-block-content">以贵阳市、贵州省范围的餐饮题材内容为主要对象，推荐美食，分享美味，聚集吃货。</p>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c2"></div>
                <h3 class="coop-block-title">合肥晚报《萌娃学堂》1期/周</h3>
                <p class="coop-block-content">一档集幽默、生活、寓教于乐三位一体的亲子节目，旨在通过孩子和主持人的互动协作，展现当代年轻父母和孩子们的交流方式。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap hsm" data-sec="0" data-third="1">
        <div class="container">
          <div class="icon-box icon lazy" v-lazy:background-image="picPath.hsm_icon">
          </div>
          <h2 class="block-title">红树莓</h2>
          <h3 class="block-subtitle">更安全、高效的移动短视频采编审发工具</h3>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.hsm"></div>
          </div>
          <div class="block-colunm-desc-wrap">
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">移动采编</h4>
              <p class="block-desc">具备远程回传、素材快速剪辑、图片合成视频、智能语音适配、人脸识别马赛克、背景音乐穿插等移动生产功能。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">三审机制</h4>
              <p class="block-desc">随时随地响应“内容批复”，方便快捷的流程实现移动指挥调度。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">多平台分发</h4>
              <p class="block-desc">通过采编后台发布至目标渠道，如自身新闻APP，或者绑定的第三方平台：腾讯 、优酷 、双微等。</p>
            </div>
          </div>
          <a href="#" class="btn">免费使用</a>
          <a href="#" class="block-remark">点击获取下载方式和相关文档</a>
          <div class="block-coop">
            <h2 class="coop-title">合作案例</h2>
            <div class="coop-content">
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c3"></div>
                <h3 class="coop-block-title">贵阳晚报《Z视频》记录型视频</h3>
                <p class="coop-block-content">溶洞篮球场、百年戴公馆、挥拳吧小汤圆<br />已发布3期。</p>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c4"></div>
                <h3 class="coop-block-title">新晚报《冰城5分熟》记录型视频</h3>
                <p class="coop-block-content">记录冰城人民风情、城市面貌<br />已发布10期。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap ai" data-sec="0" data-third="2">
        <div class="container">
          <div class="icon-box icon lazy" v-lazy:background-image="picPath.ai_icon">
          </div>
          <h2 class="block-title">AI语音合成</h2>
          <h3 class="block-subtitle bold">
            国内首家专注应用前沿人工智能语音合成技术于内容报道形态创新的平台。
          </h3>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.ai"></div>
          </div>
          <div class="block-colunm-desc-wrap">
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">多语言多音色</h4>
              <p class="block-desc">提供基础男声、女声发音，支持变调，中文、英文、中英文混读合成，支持背景音乐添加，陆续推出更多特色发音功能。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">方便快捷的集成方式</h4>
              <p class="block-desc">简单易操作，节省融媒体人力，引领行业尖端技术潮流，探索全新的内容报道形式。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">丰富的场景应用</h4>
              <p class="block-desc">特色人工智能语音播报，可运用在媒体的日常业务中，满足用户在不同场景下获取资讯的需求。</p>
            </div>
          </div>
          <a href="#" class="btn">了解详情</a>
          <a href="#" class="block-remark">点击链接查看更多内容</a>
          <div class="block-coop">
            <h2 class="coop-title">合作案例</h2>
            <div class="coop-content">
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c5"></div>
                <h3 class="coop-block-title">新快报《新新播报》1期/天</h3>
                <p class="coop-block-content">以智能语音播报前天及当天广东地区的重要新闻。</p>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c6"></div>
                <h3 class="coop-block-title">现代快报《知了新闻》1期/天</h3>
                <p class="coop-block-content">一档日常早间新闻播报类栏目。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap vr" data-sec="0" data-third="3">
        <div class="container">
          <div class="icon-box icon lazy" v-lazy:background-image="picPath.vr_icon">
          </div>
          <h2 class="block-title">威芽</h2>
          <h3 class="block-subtitle">
            “带你进入新闻现场”的沉浸式VR全景新闻生产工具
          </h3>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.vr"></div>
          </div>
          <h2 class="block-title sm">全景+新闻</h2>
          <p class="block-desc">
            把实地场景转化为可视化内容，把新闻第一现场立体化呈现，增强用户与新闻现场联结。从“看新闻”到“带你进入新闻现场”，给用户更直观、动态的理解。适用于大会报道、演唱会、体育赛事、突发现场、景区导览等等场景。 </p>
          <a href="#" class="btn">免费使用</a>
          <a href="#" class="block-remark">点击获取下载方式和相关文档</a>
          <div class="block-coop">
            <h2 class="coop-title">合作案例</h2>
            <div class="coop-content">
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c7"></div>
                <h3 class="coop-block-title">现代快报</h3>
                <p class="coop-block-content">《VR全景 | 江苏省政协十二届一次会议开幕》</p>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c8"></div>
                <h3 class="coop-block-title">今日消费</h3>
                <p class="coop-block-content">《全景VR+视频看房大集合》</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap h5" data-sec="0" data-third="4">
        <div class="container">
          <div class="icon-box icon lazy" v-lazy:background-image="picPath.h5_icon">
          </div>
          <h2 class="block-title">H5平台</h2>
          <h3 class="block-subtitle">
            用户运营、商业互动场景下的H5制作工具<br /> 含“表单、投票、测验、问卷、演示、抽奖”，满足县级融媒体日常运营需求。
          </h3>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.h5"></div>
          </div>
          <!-- <div class="block-column2-wrap">
            <div class="block-column2">
              <div class="block-column2-line">
                <span class="block-column2-line-title">表单</span>
                <span class="block-column2-line-text">用户报名、信息收集等功能。</span>
              </div>
              <div class="block-column2-line">
                <span class="block-column2-line-title">报名+投票</span>
                <span class="block-column2-line-text">用在投票评选类活动的开展。</span>
              </div>
              <div class="block-column2-line">
                <span class="block-column2-line-title">问卷、测验</span>
                <span class="block-column2-line-text">可用在趣味问答、问答比赛、创意用户互动策划等。</span>
              </div>
              <div class="block-column2-line">
                <span class="block-column2-line-title">抽奖</span>
                <span class="block-column2-line-text">包括大转盘、刮刮乐、老虎机等趣味互动形式，<br />可以配合拉新活动使用，通过抽奖刺激用户参与活动、下载客户端。</span>
              </div>
            </div>
          </div> -->
          <table class="block-h5-table">
            <tr>
              <td>表单</td>
              <td>用户报名、信息收集等功能。</td>
            </tr>
            <tr>
              <td>报名+投票</td>
              <td>用在投票评选类活动的开展。</td>
            </tr>
            <tr>
              <td>问卷、测验</td>
              <td>可用在趣味问答、问答比赛、创意用户互动策划等。</td>
            </tr>
            <tr>
              <td>抽奖</td>
              <td>包括大转盘、刮刮乐、老虎机等趣味互动形式，可以配合拉新活动使用，通过抽奖刺激用户参与活动、下载客户端。</td>
            </tr>
          </table>
          <div class="btn-box">
            <a href="#" class="btn">了解详情</a>
            <a href="#" class="block-remark">点击链接查看更多内容</a>
          </div>
          <div class="block-coop">
            <h2 class="coop-title">合作案例</h2>
            <div class="coop-content">
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c9"></div>
                <h3 class="coop-block-title">演示</h3>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c10"></div>
                <h3 class="coop-block-title">抽奖</h3>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c11"></div>
                <h3 class="coop-block-title">问卷、测试</h3>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c12"></div>
                <h3 class="coop-block-title">投票</h3>
              </div>
              <div class="coop-block">
                <div class="pic lazy" v-lazy:background-image="picPath.c13"></div>
                <h3 class="coop-block-title">表单</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap design" data-sec="0" data-third="5">
        <div class="container">
          <div class="icon-box icon lazy" v-lazy:background-image="picPath.design_icon">
          </div>
          <h2 class="block-title">云设计</h2>
          <h3 class="block-subtitle">前沿视觉效果的轻量化美编工具</h3>
          <p class="block-desc">
            可以通过此后台有效地进行图片编辑工作，云后台功能包括上传各种图片素材<br />
            和数据图表、输入文字、选择模板、设置背景样式等。
          </p>
          <!-- <h2 class="block-title sm">适用场景</h2>
          <p class="block-desc">
            可用于客户端内轮播图、APP启动页封面、专题Banner、活动海报、朋友圈传<br />播海报等的制作
          </p> -->
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.design"></div>
          </div>
          <a href="#" class="btn">了解详情</a>
          <a href="#" class="block-remark">点击链接查看更多内容</a>
        </div>
      </div>
      <div class="block-wrap tab12" data-sec="1">
        <div class="container">
          <h2 class="block-title lg">全媒体指挥调度平台</h2>
          <p class="block-desc">
            集“媒资管理、策采编发审、指挥调度”于一体，PC端与移动端配合的平台。
          </p>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.tab12"></div>
          </div>
          <div class="block-colunm-desc-wrap">
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">远程回传模块</h4>
              <p class="block-desc">支持移动终端设备采集的文字、图片、音频、视频内容等各类型文件远程回传和回传文件管理等。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">素材管理</h4>
              <p class="block-desc">支持文字、图片、音频、视频等不同类型外采资源的采集或导入，部门素材库浏览、挑选等。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">选题提交-审核流程</h4>
              <p class="block-desc">选题创建和编辑、选题筛选、选题审核派发、组合报道等。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">指挥调度</h4>
              <p class="block-desc">任务创建、指派、确认、状态查询、即时通讯等。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab2" data-sec="2">
        <div class="container">
          <h2 class="block-title lg">内容安全三审系统</h2>
          <p class="block-desc">
            共享ZAKER现有的安全防控体系，包括敏感内容智能识别预警、评论管理系统、反黑客攻击、账号管理系统等，通过移动端实现实时提交、实时审核，高效便捷。
          </p>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.nrss"></div>
          </div>
          <div class="block-colunm-desc-wrap">
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">报提审核</h4>
              <p class="block-desc">支持选题移动审核、派发。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">发布审核</h4>
              <p class="block-desc">发布渠道的发布前、发布后内容进行三级审核流程。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">安全防控</h4>
              <p class="block-desc">包括敏感内容人工智能识别预警、评论分级管理系统、反黑客攻击、审核人员工作日志、统计报表等。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab6" data-sec="3">
        <div class="container">
          <h2 class="block-title lg">全媒体舆情监控系统</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab61"></div>
              <h3 class="block-content-column-title">全网信息监测</h3>
              <p class="block-content-column-desc">采集监测“网站、微信、微博、客户端、纸媒”等全网信息</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab62"></div>
              <h3 class="block-content-column-title">热点发现</h3>
              <p class="block-content-column-desc">分析全网热点和舆论发展趋势，掌握地方重点事件，预测、发现热点走势，为内容生产提供指导。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab65"></div>
              <h3 class="block-content-column-title">舆情预警</h3>
              <p class="block-content-column-desc">实时舆情预警，后台、电话、短信警报</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab63"></div>
              <h3 class="block-content-column-title">舆情报告</h3>
              <p class="block-content-column-desc">舆情日报，月报，季度报，年报</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab64"></div>
              <h3 class="block-content-column-title">事件回溯</h3>
              <p class="block-content-column-desc">事件（领导、专题、政情等）定向监测，回溯分析报告</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab66"></div>
              <h3 class="block-content-column-title">方案设置</h3>
              <p class="block-content-column-desc">针对特定“事件”自主设置舆情预警及监测方案，实时预测热点、舆情事件发生的可能性</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab4" data-sec="4">
        <div class="container">
          <h2 class="block-title lg">内容管理平台</h2>
          <!-- <div class="block-desc">
            <div class="block-column-desc">
              <p>· 分析全网热点和舆论发展趋势。</p>
              <p>· 掌握地方重点事件，生产定制化内容，增加用户黏度。 </p>
            </div>
            <div class="block-column-desc">
              <p>· 细分目标用户，预测、发现热点走势，精准传递价值资讯。</p>
              <p>· 数据安全管理，分账号分权限，进行数据安全管理。 </p>
            </div>
          </div> -->
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.tab4"></div>
          </div>
          <div class="block-colunm-desc-wrap">
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">内容管理</h4>
              <p class="block-desc">全媒体数字资料的存储管理、检索及再利用，包括资源“入库、管理、检索、展现、出库、分级存储”等。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">内容编辑</h4>
              <p class="block-desc">支持新闻稿件的多级审核、编辑、选用、推送、分享等功能。</p>
            </div>
            <div class="block-colunm-desc">
              <h4 class="block-colunm-desc-title">数据分析</h4>
              <p class="block-desc">支持对用户点击、转发、评论等数据的采集，频道发稿情况的统计，编辑/记者发稿情况的统计。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab5" data-sec="5">
        <div class="container">
          <h2 class="block-title lg">用户管理系统</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab51"></div>
              <h3 class="block-content-column-title">用户分级管理</h3>
              <p class="block-content-column-desc">按照用户活跃度、贡献度将用户进行划分，重点做好核心用户高价值用户的关系维护。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab52"></div>
              <h3 class="block-content-column-title">用户安全管理</h3>
              <p class="block-content-column-desc">对用户平台账号、昵称、头像、评论、发帖、扰乱平台秩序等进行管理。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab53"></div>
              <h3 class="block-content-column-title">用户行为统计</h3>
              <p class="block-content-column-desc">建立数据模型，分析用户行为，即阅读习惯及喜好，提升媒体社会影响力。</p>
            </div>
            <!-- <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab54"></div>
              <h3 class="block-content-column-title">用户热点</h3>
              <p class="block-content-column-desc">实现热点线索的预测和发现，监测热点新闻事件的报道详情，帮助编辑发现爆款，快速提取网民兴趣热点。</p>
            </div> -->
          </div>
        </div>
      </div>
      <div class="block-wrap tab3" data-sec="6">
        <div class="container">
          <h2 class="block-title lg">融合发布系统</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab31"></div>
              <h3 class="block-content-column-title">系统对接</h3>
              <p class="block-content-column-desc">系统接口对接，包含不限于：APP、双微、网站、新旧系统等。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab32"></div>
              <h3 class="block-content-column-title">一键分发</h3>
              <p class="block-content-column-desc">实现一体策划、一次采集、多种生成、一键分发，多元传播的建设理念。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab15" data-sec="7">
        <div class="container">
          <h2 class="block-title lg">可视化呈现</h2>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.tab15"></div>
          </div>
          <p class="block-desc">
            支持多种业务数据信息的可视化呈现，包括互联网汇聚数据、报题或选题数据、生产或发布的内容数据、新闻生产流程状态数据、指挥调度信息、新闻传播影响力结果等。
          </p>
        </div>
      </div>
      <div class="block-wrap tab13" data-sec="8">
        <div class="container">
          <h2 class="block-title lg">绩效统计系统</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab131"></div>
              <h3 class="block-content-column-title">多维考核</h3>
              <p class="block-content-column-desc">支持结合具体的绩效管理统计办法进行绩效考核统计设定，如：发稿数、转发数、评论数、观看量、价值性、影响力等。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab132"></div>
              <h3 class="block-content-column-title">数据导出</h3>
              <p class="block-content-column-desc">可以按人员、按时段、按类型等分类一键导出。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab10" data-sec="9">
        <div class="container">
          <h2 class="block-title lg">广告投放系统</h2>
          <div class="block-content">
            <div class="block-line">
              <div class="block-content-column">
                <div class="pic lazy" v-lazy:background-image="picPath.tab102"></div>
                <h3 class="block-content-column-title">排期系统</h3>
                <p class="block-content-column-desc">对计划投放、已投放的广告进行点位、排期管理。</p>
              </div>
              <div class="block-content-column">
                <div class="pic lazy" v-lazy:background-image="picPath.tab103"></div>
                <h3 class="block-content-column-title">广告类型</h3>
                <p class="block-content-column-desc">支持CPD、CPC、CPM、创意广告、内容定制型广告产品样式等。</p>
              </div>
            </div>
            <div class="block-line">
                <div class="block-content-column">
                  <div class="pic lazy" v-lazy:background-image="picPath.tab101"></div>
                  <h3 class="block-content-column-title">广告上线</h3>
                  <p class="block-content-column-desc">对广告素材进行内测、预览、上线操作。</p>
                </div>
              <div class="block-content-column">
                <div class="pic lazy" v-lazy:background-image="picPath.tab104"></div>
                <h3 class="block-content-column-title">数据统计</h3>
                <p class="block-content-column-desc">含广告曝光、点击数据查看。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab11" data-sec="10">
        <div class="container">
          <h2 class="block-title lg">营销服务平台</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab111"></div>
              <h3 class="block-content-column-title">案例共享</h3>
              <p class="block-content-column-desc">平台月度、季度、年度项目规划及联动征集。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab113"></div>
              <h3 class="block-content-column-title">专家智库</h3>
              <p class="block-content-column-desc">构建各行业专家智库，输出行业报告，专业辅助决策。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab112"></div>
              <h3 class="block-content-column-title">策略支持</h3>
              <p class="block-content-column-desc">从每个节点的招商方案输出、个案辅助制作，到跨城市商业案例复制再造；从各类营销玩法教授，到运用数据做结案分析。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab114"></div>
              <h3 class="block-content-column-title">传播资源</h3>
              <p class="block-content-column-desc">综合线上线下全网覆盖、跨媒体跨城市联动传播，从渠道资源到创意广告、到内容产品，合作超越资源本身。</p>
            </div>
          </div>
          <div class="block-coop">
            <h2 class="coop-title">合作案例</h2>
            <div class="coop-content">
              <div class="coop-block one">
                <div class="pic lazy" v-lazy:background-image="picPath.c14"></div>
                <div class="right">
                  <h3 class="coop-block-title">新晚报</h3>
                  <p class="coop-block-content">
                    2018年ZAKER哈尔滨旅发委全案营销。借助线上线下、跨城市传播，项目总曝光量达9400余万。其中：<br />
                    ·《行行摄摄大美冰城》更是成为推介旅游、营销城市的经典案例；<br />
                    ·《旅发大会》，霸屏式宣传报道，向全国范围更多的目标潜在客户展示了强大的内容生产能力、技术运用能力、全媒体推广能力。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab9" data-sec="11">
        <div class="container">
          <h2 class="block-title lg">政务号服务</h2>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.tab9"></div>
          </div>
          <p class="block-desc">
            为政府部门提供政务号运营，推进政务公开、优化政务服务、凝聚社会共识、创新社会治理。
          </p>
        </div>
      </div>
      <div class="block-wrap tab7" data-sec="12">
        <div class="container">
          <h2 class="block-title lg">APP搭建</h2>
          <p class="block-desc">
            具备内容聚合自媒体/政务号订阅体系、兴趣推荐算法、视听（直播、点播）体系、生活服务板块体系、个人主页用户管理体系。<br />
            支持文、图、视频、直播、VR、H5等内容发布。
          </p>
          <div class="block-content">
            <div class="pic lazy" v-lazy:background-image="picPath.tab7"></div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab8" data-sec="13">
        <div class="container">
          <h2 class="block-title lg">小程序开发</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab81"></div>
              <h3 class="block-content-column-title">Saas平台</h3>
              <p class="block-content-column-desc">集成多个功能模板，快速生成如垂直资讯、政务发布、民生服务等不同业务场景小程序。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab82"></div>
              <h3 class="block-content-column-title">小程序</h3>
              <p class="block-content-column-desc">以微信的社交场景为依托，打造如“权威养生图文资讯”、“经济民生语音播报”等多形态、易传播的社交资讯阵地。</p>
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap tab14" data-sec="14">
        <div class="container">
          <h2 class="block-title lg">内容共享及版权管理系统</h2>
          <div class="block-content">
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab141"></div>
              <h3 class="block-content-column-title">版权代理</h3>
              <p class="block-content-column-desc">支持原创认定，为授权的版权方提供线上线下版权交易、内容共享代理等服务。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab142"></div>
              <h3 class="block-content-column-title">维权服务</h3>
              <p class="block-content-column-desc">用非诉、诉讼手段帮助媒体提升版权品牌价值，提高媒体版权变现收益。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab143"></div>
              <h3 class="block-content-column-title">网页存证</h3>
              <p class="block-content-column-desc">与公证处合作的原创电子公证服务，存证“实时高效，公正、权威、价格便宜”。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab144"></div>
              <h3 class="block-content-column-title">转载分析</h3>
              <p class="block-content-column-desc">提供原创稿件全网的实时传播路径，稿件转载明细，媒体转载详情。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab145"></div>
              <h3 class="block-content-column-title">侵权预警</h3>
              <p class="block-content-column-desc">及时报告乙方侵权行为，并规避自身“非法”转载。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab146"></div>
              <h3 class="block-content-column-title">律师联盟</h3>
              <p class="block-content-column-desc">提供专业律师属地化服务，提供跨区域媒体版权服务支持。</p>
            </div>
            <div class="block-content-column">
              <div class="pic lazy" v-lazy:background-image="picPath.tab147"></div>
              <h3 class="block-content-column-title">在线交易</h3>
              <p class="block-content-column-desc">线上图片、视频素材上传到平台审核通过后，综合定价，在线交易管理。</p>
            </div>
            <div class="block-content-column"></div>
          </div>
        </div>
      </div>
      <div class="block-wrap cooper-type">
        <div class="container">
          <h2 class="cooper-title">合作方式</h2>
          <h3 class="cooper-subtitle">全媒体内容生产工具，开通账号即可使用，一站式服务、一秒上手、快速发布，<br />轻便灵活，成本更低。</h3>
          <div class="cooper-content">
            <div class="cooper-block">
              <div class="cooper-block-title">体验版</div>
              <p class="cooper-block-text">
                申请一个测试账号，一键登录体验系列产品。
              </p>
            </div>
            <div class="cooper-block">
              <div class="cooper-block-title">专业版</div>
              <p class="cooper-block-text">
                服务包含但不限于：云服务、账号体系、数据管理等。更多融媒体产品、服务解决方案，可沟通定制
              </p>
            </div>
          </div>
          <div class="cooper-bottom">
            <div class="text">更多项目合作 商务咨询</div>
            <div class="text">020-38488576 / 13570964521 <br />
              lifenni@myzaker.com
            </div>
          </div>
        </div>
      </div>
      <div class="block-wrap cooper-media">
        <div class="container">
          <h2 class="cooper-title">合作媒体</h2>
          <h3 class="cooper-subtitle">融媒体合作伙伴</h3>
          <div class="cooper-content clearfix">
            <a href="http://wb.sznews.com/PC/layout/201908/27/node_A01.html" title="深圳晚报" class="cooper-link"
              target="_blank">
              深圳晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic1"></div>
            </a>
            <a href="http://www.jnds.com.cn/" title="江南都市报" class="cooper-link" target="_blank">
              江南都市报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic2"></div>
            </a>
            <a href="https://www.dahe.cn/" title="今日消费" class="cooper-link" target="_blank">
              今日消费
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic3"></div>
            </a>
            <a href="http://xdkb.net/" title="现代快报" class="cooper-link" target="_blank">
              现代快报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic4"></div>
            </a>
            <a href="http://www.nnnews.net/" title="南宁晚报" class="cooper-link" target="_blank">
              南宁晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic5"></div>
            </a>
            <a href="http://www.xkb.com.cn/" title="新快报" class="cooper-link" target="_blank">
              新快报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic6"></div>
            </a>
            <a href="http://www.hf365.com/" title="合肥晚报" class="cooper-link" target="_blank">
              合肥晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic7"></div>
            </a>
            <a href="http://www.lnd.com.cn/" title="辽沈晚报" class="cooper-link" target="_blank">
              辽沈晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic8"></div>
            </a>
            <a href="http://epaper.heyuan.cn/html/2019-08/27/node_1.htm" title="河源日报" class="cooper-link" target="_blank">
              河源日报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic9"></div>
            </a>
            <a href="http://www.gywb.cn/" title="贵阳晚报" class="cooper-link" target="_blank">
              贵阳晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic10"></div>
            </a>
            <a href="http://www.sjzdaily.com.cn/" title="燕赵晚报" class="cooper-link" target="_blank">
              燕赵晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic11"></div>
            </a>
            <a href="http://www.sunnews.cn/" title="海西晨报" class="cooper-link" target="_blank">
              海西晨报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic12"></div>
            </a>
            <a href="http://www.hilizi.com/" title="半岛晨报" class="cooper-link" target="_blank">
              半岛晨报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic13"></div>
            </a>
            <a href="http://www.qhdnews.com/" title="秦皇岛日报" class="cooper-link" target="_blank">
              秦皇岛日报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic14"></div>
            </a>
            <a href="http://www.lzbs.com.cn/" title="兰州日报" class="cooper-link" target="_blank">
              兰州日报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic15"></div>
            </a>
            <a href="http://www.my399.com/" title="新晚报" class="cooper-link" target="_blank">
              新晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic16"></div>
            </a>
            <a href="http://www.bdall.com/" title="保定晚报" class="cooper-link" target="_blank">
              保定晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic17"></div>
            </a>
            <a href="http://www.xxcb.cn/" title="潇湘晨报" class="cooper-link" target="_blank">
              潇湘晨报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic18"></div>
            </a>
            <a href="http://www.taiandaily.com.cn/" title="泰安日报" class="cooper-link" target="_blank">
              泰安日报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic19"></div>
            </a>
            <a href="#" title="" class="cooper-link" target="_blank">
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic20"></div>
            </a>
            <a href="#" title="" class="cooper-link" target="_blank">
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic21"></div>
            </a>
            <a href="http://www.xwh.cn/" title="新文化报" class="cooper-link" target="_blank">
              新文化报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic22"></div>
            </a>
            <a href="#" title="" class="cooper-link" target="_blank">
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic23"></div>
            </a>
            <a href="http://www.ycwb.com/" title="羊城晚报" class="cooper-link" target="_blank">
              羊城晚报
              <div class="pic lazy" v-lazy:background-image="picPath.cooper.pic24"></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap_footer" id="wrap_footer">
      <div id="footer_inner">
        <span>Copyright © 2011-2019 ZAKER.All Rights Reserved</span>
        <div id="footer1"></div>
        <div id="footer2"></div>
        <a href="http://www.miibeian.gov.cn/" target="_blank">粤ICP备12019658号-1</a>&nbsp;&nbsp;<font color="#ff5050
      ">/</font>&nbsp;&nbsp;<a href="//www.myzaker.com/images/new/bottom/XKZ1.jpg"
          target="_blank">ICP证粤B2-20130159</a>&nbsp;&nbsp;<font color="#ff5050
      ">/</font>&nbsp;&nbsp;网络出版服务许可证：<a href="//www.myzaker.com/images/new/bottom/XKZ3.jpg"
          target="_blank">（总）网出证（粤）字第050号</a>&nbsp;&nbsp;<font color="#ff5050
      ">/</font>&nbsp;&nbsp;<a href="//www.myzaker.com/images/new/bottom/XKZ2_.jpg"
          target="_blank">增值电信业务经营许可证B2-20150871</a>
        <div id="footer3"></div>
        网络文化经营许可证：<a href="//www.myzaker.com/images/new/bottom/XKZ1.jpg"
          target="_blank">粤网文[2018]6864-2439号</a>&nbsp;&nbsp;<font color="#ff5050
      ">/</font>&nbsp;&nbsp;法律邮箱：law@myzaker.com&nbsp;&nbsp;<font color="#ff5050">/</font>&nbsp;&nbsp;<a
          target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602001315"
          style="display:inline-block;"><img src="//www.myzaker.com/images/new/bottom/ga.png"
            style="float:left;margin: 0 5px 0 0;" />
          <p style="display: inline;color:#939393;">粤公网安备 44010602001315号</p>
        </a>
        <div id="footer4"></div>
        <a href="http://www.gzaic.gov.cn/" target="_blank"><img src="//www.myzaker.com/images/new/bottom/1.png"
            class="bottomimg" /></a>
        <a href="http://www.gzjd.gov.cn/" target="_blank"><img src="//www.myzaker.com/images/new/bottom/2.png"
            class="bottomimg" /></a>
      </div>
    </div>

    <r-login></r-login>
  </div>
</template>

<script>
import {scrollToEle} from "../utils";
import mixin from "../mixins";
import "../mock/index.js";

import rLogin from "../components/r-login";

export default {
  components: {rLogin},
  mixins: [mixin],
  data() {
    return {
      picPath: {
        b1: "//zkres.myzaker.com/static/rmt/b1.png",
        b2: "//zkres.myzaker.com/static/rmt/b2.png",
        b3: "//zkres.myzaker.com/static/rmt/b3.png",
        b4: "//zkres.myzaker.com/static/rmt/b4.png",
        live_icon: "//zkres.myzaker.com/static/rmt/live_icon.png",
        live: "//zkres.myzaker.com/static/rmt/live.png",
        live5: "//zkres.myzaker.com/static/rmt/live5.png",
        c1: "//zkres.myzaker.com/static/rmt/c1.png",
        c2: "//zkres.myzaker.com/static/rmt/c2.png",
        hsm_icon: "//zkres.myzaker.com/static/rmt/hsm_icon.png",
        hsm: "//zkres.myzaker.com/static/rmt/hsm.png",
        c3: "//zkres.myzaker.com/static/rmt/c3.png",
        c4: "//zkres.myzaker.com/static/rmt/c4.png",
        ai_icon: "//zkres.myzaker.com/static/rmt/ai_icon.png",
        ai: "//zkres.myzaker.com/static/rmt/ai.png",
        c5: "//zkres.myzaker.com/static/rmt/c5.png",
        c6: "//zkres.myzaker.com/static/rmt/c6.png",
        vr_icon: "//zkres.myzaker.com/static/rmt/vr_icon.png",
        vr: "//zkres.myzaker.com/static/rmt/vr.png",
        c7: "//zkres.myzaker.com/static/rmt/c7.png",
        c8: "//zkres.myzaker.com/static/rmt/c8.png",
        h5_icon: "//zkres.myzaker.com/static/rmt/h5_icon.png",
        h5: "//zkres.myzaker.com/static/rmt/h5.png",
        c9: "//zkres.myzaker.com/static/rmt/c9.png",
        c10: "//zkres.myzaker.com/static/rmt/c10.png",
        c11: "//zkres.myzaker.com/static/rmt/c11.png",
        c12: "//zkres.myzaker.com/static/rmt/c12.png",
        c13: "//zkres.myzaker.com/static/rmt/c13.png",
        design_icon: "//zkres.myzaker.com/static/rmt/design_icon.png",
        design: "//zkres.myzaker.com/static/rmt/design.png",
        tab12: "//zkres.myzaker.com/static/rmt/tab12.png",
        nrss: "//zkres.myzaker.com/static/rmt/nrss.png",
        tab61: "//zkres.myzaker.com/static/rmt/tab61.png",
        tab62: "//zkres.myzaker.com/static/rmt/tab62.png",
        tab63: "//zkres.myzaker.com/static/rmt/tab63.png",
        tab64: "//zkres.myzaker.com/static/rmt/tab64.png",
        tab65: "//zkres.myzaker.com/static/rmt/tab65.png",
        tab66: "//zkres.myzaker.com/static/rmt/tab66.png",
        tab4: "//zkres.myzaker.com/static/rmt/tab4.png",
        tab51: "//zkres.myzaker.com/static/rmt/tab51.png",
        tab52: "//zkres.myzaker.com/static/rmt/tab52.png",
        tab53: "//zkres.myzaker.com/static/rmt/tab53.png",
        tab54: "//zkres.myzaker.com/static/rmt/tab54.png",
        tab31: "//zkres.myzaker.com/static/rmt/tab31.png",
        tab32: "//zkres.myzaker.com/static/rmt/tab32.png",
        tab15: "//zkres.myzaker.com/static/rmt/tab15.png",
        tab131: "//zkres.myzaker.com/static/rmt/tab131.png",
        tab132: "//zkres.myzaker.com/static/rmt/tab132.png",
        tab102: "//zkres.myzaker.com/static/rmt/tab102.png",
        tab103: "//zkres.myzaker.com/static/rmt/tab103.png",
        tab101: "//zkres.myzaker.com/static/rmt/tab101.png",
        tab104: "//zkres.myzaker.com/static/rmt/tab104.png",
        tab111: "//zkres.myzaker.com/static/rmt/tab111.png",
        tab113: "//zkres.myzaker.com/static/rmt/tab113.png",
        tab112: "//zkres.myzaker.com/static/rmt/tab112.png",
        tab114: "//zkres.myzaker.com/static/rmt/tab114.png",
        c14: "//zkres.myzaker.com/static/rmt/c14.png",
        tab9: "//zkres.myzaker.com/static/rmt/tab9.png",
        tab7: "//zkres.myzaker.com/static/rmt/tab7.png",
        tab81: "//zkres.myzaker.com/static/rmt/tab81.png",
        tab82: "//zkres.myzaker.com/static/rmt/tab82.png",
        tab141: "//zkres.myzaker.com/static/rmt/tab141.png",
        tab142: "//zkres.myzaker.com/static/rmt/tab142.png",
        tab143: "//zkres.myzaker.com/static/rmt/tab143.png",
        tab144: "//zkres.myzaker.com/static/rmt/tab144.png",
        tab145: "//zkres.myzaker.com/static/rmt/tab145.png",
        tab146: "//zkres.myzaker.com/static/rmt/tab146.png",
        tab147: "//zkres.myzaker.com/static/rmt/tab147.png",
        cooper: {
          pic1: "//zkres.myzaker.com/static/rmt/m1.png",
          pic2: "//zkres.myzaker.com/static/rmt/m2.png",
          pic3: "//zkres.myzaker.com/static/rmt/m3.png",
          pic4: "//zkres.myzaker.com/static/rmt/m4.png",
          pic5: "//zkres.myzaker.com/static/rmt/m5.png",
          pic6: "//zkres.myzaker.com/static/rmt/m6.png",
          pic7: "//zkres.myzaker.com/static/rmt/m7.png",
          pic8: "//zkres.myzaker.com/static/rmt/m8.png",
          pic9: "//zkres.myzaker.com/static/rmt/m9.png",
          pic10: "//zkres.myzaker.com/static/rmt/m10.png",
          pic11: "//zkres.myzaker.com/static/rmt/m11.png",
          pic12: "//zkres.myzaker.com/static/rmt/m12.png",
          pic13: "//zkres.myzaker.com/static/rmt/m13.png",
          pic14: "//zkres.myzaker.com/static/rmt/m14.png",
          pic15: "//zkres.myzaker.com/static/rmt/m15.png",
          pic16: "//zkres.myzaker.com/static/rmt/m16.png",
          pic17: "//zkres.myzaker.com/static/rmt/m17.png",
          pic18: "//zkres.myzaker.com/static/rmt/m18.png",
          pic19: "//zkres.myzaker.com/static/rmt/m19.png",
          pic20: "//zkres.myzaker.com/static/rmt/m20.png",
          pic21: "//zkres.myzaker.com/static/rmt/m21.png",
          pic22: "//zkres.myzaker.com/static/rmt/m22.png",
          pic23: "//zkres.myzaker.com/static/rmt/m23.png",
          pic24: "//zkres.myzaker.com/static/rmt/m24.png",
        },
        banner: WinResourcesDirectory + require('../assets/img/banner2.jpg')
      },
      isScroll: false,
      isClickScroll: false,
      scrollRate: 7, // 滑动的速率
      secCur: null,
      timer: null,
      openTimer: false
    }
  },
  computed: {
  },
  mounted() {
    this.scrollEvent()
    this.initFixedNavBar()
    this.bindEvent()
  },
  methods: {
    initFixedNavBar() {
      const $barHtml = $('.nav-list').clone(true);
      $('.fixed-nav').append($barHtml);
    },
    scrollEvent() {
      const top = $('.fixed-nav-wrap').height();
      const scrolltop = $(window).scrollTop();
      this.navShowLogic(top, scrolltop);
      if(scrolltop>top) {
        $('.fixed-nav-wrap').show();
      } else {
        $('.fixed-nav-wrap').hide();
      }
    },
    navShowLogic(top, scrolltop) {
      if (this.openTimer) return;
      clearTimeout(this.timer);
      const $thirdBlock = $('[data-third]');
      const $secBlock = $('[data-sec]');
      const firstBlockOffset = 100;  // 直播tab滚动识别偏移值
      let showThirdCur = null;
      $thirdBlock.each(function(index) {
        let theshold = $(this).offset().top-top;
        if(index === 0) theshold = theshold - firstBlockOffset;
        if(theshold <= scrolltop+10) {
          showThirdCur = $(this).attr('data-third')-0;
        }
      });
      const secLen = $secBlock.length;
      const thirdLen = $thirdBlock.length;
      const $subNavWrap = $('.sub-nav-wrap');
      const $subNavList = $('.sub-nav-list');

      if($thirdBlock.eq(thirdLen-1).offset().top - top + $thirdBlock.eq(thirdLen-1).height() < scrolltop) {
        showThirdCur = null;
      }

      $secBlock.each((index, item) => {
        let theshold = $(item).offset().top-$('.fixed-nav-wrap').height();
        if(index === 0) theshold = theshold - firstBlockOffset;
        if(theshold <= scrolltop) {
          this.secCur = $(item).attr('data-sec')-0;
        }
      });
      
      if($secBlock.eq(secLen-1).offset().top - top + $secBlock.eq(secLen-1).height() < scrolltop || $secBlock.eq(0).offset().top-firstBlockOffset-$('.fixed-nav-wrap').height() > scrolltop) {
        this.secCur = null;
      }

      if(showThirdCur !== null) {
        $subNavWrap.addClass('show');
      } else {
        $subNavWrap.removeClass('show');
      }

      const clsHandle = () => {
        $('.nav-list>a').removeClass('active');
        if(this.secCur !== null) {
          $('.nav-list>a').eq(this.secCur).addClass('active');
        }
  
        if(showThirdCur !== null) {
          $subNavList.find('a').removeClass('active');
          $subNavList
            .eq(this.secCur)
            .find('a')
            .eq(showThirdCur)
            .addClass('active');
          $subNavWrap.addClass('show');
        }
      };

      // 是否开启延时处理，普通滚动不开启，点击滚动类型的开启，为了让滚动的时候tab的高亮不会抖
      if(this.openTimer) {
        this.timer = setTimeout(() => {
          clsHandle();
        }, 300);
      } else {
        clsHandle();
      }
    },
    bindEvent() {
      const that = this
      // 顶部导航滚动操作
      $('.menu-list>a').on('click', function () {
        const idx = $(this).index();
        let top = 0;
        switch (idx) {
          case 0:
            top = $('.cooper-type').offset().top;
            break;
        }
        if(top) top -= $('.fixed-nav-wrap').height();
        scrollToEle({
          el: top,
          scrollRate: that.scrollRate
        });
      });

      // 二级导航滚动操作
      $('.nav-list>a').on('click', function () {
        if (that.isScroll) return;
        $('.nav-list>a').removeClass('active');
        $(this).addClass('active');
        const idx = $(this).index();
        if(idx === 0) {
          const $navList = $('.sub-nav-list').eq(idx); 
          $navList
            .find('a')
            .eq(0)
            .trigger('click');
        } else {
          that.openTimer = true;
          that.isScroll = true;
          let top = $(`[data-sec='${idx}']`).offset().top - $('.fixed-nav-wrap').height();
          console.log({
             el: top,
            scrollRate: that.scrollRate
          })
          scrollToEle({
            el: top,
            scrollRate: that.scrollRate,
            finish: () => {
              that.isScroll = false
              that.openTimer = false
            }
          });
        }
      });

      // 三级导航滚动操作
      $('.sub-nav-list>a').on('click', function () {
        if(that.isScroll) return;
        that.openTimer = true;
        $('.sub-nav-list>a').removeClass('active');
        $(this).addClass('active');
        const cls = $(this).attr('data-cls');
        let top = $(`.block-wrap.${cls}`).offset().top;
        top -= $('.fixed-nav-wrap').height();
        that.isScroll = true;
        scrollToEle({
          el: top,
          scrollRate: that.scrollRate,
          finish: () => {
            that.isScroll = false
            that.openTimer = false
          }
        });
      });

      // 使用、了解详情按钮
      $('.block-wrap .btn').on('click', function() {
        $('.menu-list>a').eq(0).trigger('click');
      });

      $(window).on('scroll', this.scrollEvent);
    }
  }
};

</script>

<style lang="less">
@import "../assets/css/reset.less";
@import "../assets/css/index.less";
</style>



// WEBPACK FOOTER //
// index.vue?3af4e1a2